/**
 * Customer settings API client (BFF: `/api/v1/store/settings/customers`).
 */
import { apiClient } from '@/shared/api';
import type { CustomerSettings, UpdateCustomerSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/customers';

export const getCustomerSettings = async (): Promise<CustomerSettings> =>
  (await apiClient.get<CustomerSettings>(BASE)).data;

export const updateCustomerSettings = async (
  body: UpdateCustomerSettingsRequest,
): Promise<CustomerSettings> => (await apiClient.put<CustomerSettings>(BASE, body)).data;
